import { connect } from "react-redux"
import VisualizationConsole from "search-new/components/Visualization/VisualizationConsole/index"

import {
    selectActiveVisualization,
    selectActiveVisualizationId,
    selectPermissionedButtonGroups,
    selectShouldShowVisualizationConsoleBar,
} from "search-new/selectors"

import {
    setActiveVisualization,
} from "search-new/action-creators"

const mapStateToProps = (state, props) => ({
    activeVisualization: selectActiveVisualization(state, props),
    activeVisualizationId: selectActiveVisualizationId(state, props),
    permissionedButtonGroups: selectPermissionedButtonGroups(state, props),
    shouldShowVisualizationConsoleBar: selectShouldShowVisualizationConsoleBar(state, props),
})

const actions = {
    setActiveVisualization,
}

export default connect(mapStateToProps, actions)(VisualizationConsole)
